 <template>
  <div class="selected mb-5">
    <div class="row mb-2">
      <div class="col">
        <h1>{{ $t("traveldata") }}</h1>
      </div>
      <div class="col-auto">
         <button class="btn btn-primary" @click="resetAll">
             {{ $t("edit") }}
           </button>
      </div>
    </div>
    <div class="selected-search-summary">
      <div class="row ">
         <div class="col">
           {{ $t("From") }} {{ niceDate(reservation.startdate) }} {{ $t("to") }}:
           {{ niceDate(reservation.enddate) }}<br />
        
           <!-- <strong>{{ $t("adults") }}:</strong> {{ params.adults }}
            <span v-if="params.children">
              <strong>{{ $t("children") }}: </strong>{{ params.children }}
            </span> -->
         </div>
         <div class="col justify-content-start">
          {{ $t("nights") }}: {{ reservation.nights }}<br />
         </div>
       </div>
    </div>
    
  </div>
</template>

<script>
export default {
  setup() {},
  methods: {
    resetAll() {
      console.log("reset");
      window.location.reload();
    },
  },
};
</script>
